import { createContext, useContext, useState, useCallback } from "react";

const defaultFilters = {
  q:                 "",
  comarca:           "",
  dateFrom:          null,
  dateTo:            null,
  category:          "all",
  type:              "all",   // "machine" | "finca" | "all"
  minPrice:          0,
  maxPrice:          500,
  minRating:         0,
  deliveryAvailable: false,
  page:              1,
};

const SearchContext = createContext(null);

export function SearchProvider({ children }) {
  const [filters, setFiltersState] = useState(() => {
    try {
      const stored = sessionStorage.getItem("leiro_filters");
      return stored ? { ...defaultFilters, ...JSON.parse(stored) } : defaultFilters;
    } catch { return defaultFilters; }
  });

  const setFilters = useCallback((updater) => {
    setFiltersState(prev => {
      const next = typeof updater === "function" ? updater(prev) : { ...prev, ...updater };
      try { sessionStorage.setItem("leiro_filters", JSON.stringify(next)); } catch {}
      return next;
    });
  }, []);

  const resetFilters = useCallback(() => {
    setFiltersState(defaultFilters);
    try { sessionStorage.removeItem("leiro_filters"); } catch {}
  }, []);

  return (
    <SearchContext.Provider value={{ filters, setFilters, resetFilters, defaultFilters }}>
      {children}
    </SearchContext.Provider>
  );
}

export const useSearch = () => {
  const ctx = useContext(SearchContext);
  if (!ctx) throw new Error("useSearch must be used inside SearchProvider");
  return ctx;
};
